import { render, staticRenderFns } from "./registran.vue?vue&type=template&id=756c9644&"
import script from "./registran.vue?vue&type=script&lang=js&"
export * from "./registran.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports